export default {
    org: "lotCount",
    palette: {
        background: {
            default: "#fff"
        },
        error: {
            main: "#ee315e"
        },
        primary: {
            main: "#f2a52e"
        },
        secondary: {
            main: "#afbdbc"
        },
        tertiary: {
            main: "#090605"
        },
        common: {
            white: "#fff"
        },
        default: {
            main: "#afbdbc"
        }
    },
    typography: {
        fontFamily: ["Cabin", "sans-serif"].join(",")
    },
    components: {
        MuiButton: {
            styleOverrides: {
                /** Theming structure */
                containedDefault: {
                    background: "#afbdbc",
                    color: "#090605"
                },
                containedPrimary: {
                    color: "#fff"
                },
                outlinedPrimary: {
                    color: "#f2a52e"
                },
                containedSecondary: {
                    color: "#fff"
                },
                outlinedSecondary: {
                    color: "#afbdbc"
                },
                containedError: {
                    background: "#ee315e",
                    color: "#fff"
                },
                outlinedError: {
                    color: "#ee315e"
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                columnHeaders: {
                    color: "#f2a52e",
                    "&  svg": {
                        color: "#f2a52e"
                    }
                },
                footerContainer: {
                    "& svg": {
                        color: "#f2a52e"
                    }
                }
            }
        }
    },
    overrides: {},
    shape: {
        borderRadius: 1
    }
};
